// Turns a pasted video URL (YouTube, Vimeo, Google Drive, or a raw file URL)
// into an embeddable {type, src} pair. Same approach as the Little Verses
// admin's media.js: host allowlist per provider, native URL/URLSearchParams
// parsing, Vimeo id found by scanning path segments for the first all-digit
// one (works for vimeo.com/<id>, /channels/x/<id>, /groups/x/videos/<id>,
// and already-canonical player.vimeo.com/video/<id>?h=<hash> alike).
const YT_HOSTS = new Set(["www.youtube.com", "youtube.com", "youtu.be", "m.youtube.com"]);
const DRIVE_HOSTS = new Set(["drive.google.com"]);
const VIMEO_HOSTS = new Set(["vimeo.com", "www.vimeo.com", "player.vimeo.com"]);

export function detectMedia(url) {
  if (!url) return { type: "none", src: "" };
  const trimmed = url.trim();
  if (!trimmed) return { type: "none", src: "" };

  const withProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(trimmed) ? trimmed : `https://${trimmed}`;
  let u;
  try {
    u = new URL(withProtocol);
  } catch {
    return { type: "direct", src: trimmed };
  }
  const host = u.hostname.toLowerCase();

  if (YT_HOSTS.has(host)) {
    let id = u.searchParams.get("v");
    if (!id) {
      const parts = u.pathname.split("/").filter(Boolean);
      // youtu.be/<id>, /embed/<id>, /live/<id>, /shorts/<id>
      id = parts[parts.length - 1];
      if (["embed", "live", "shorts"].includes(parts[0]) && parts[1]) id = parts[1];
    }
    if (id) return { type: "youtube", src: `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1` };
  }

  if (VIMEO_HOSTS.has(host)) {
    const parts = u.pathname.split("/").filter(Boolean);
    const idIdx = parts.findIndex((p) => /^\d+$/.test(p));
    const id = idIdx >= 0 ? parts[idIdx] : "";
    const hash = u.searchParams.get("h") || parts[idIdx + 1] || "";
    if (id) {
      const embed = new URL(`https://player.vimeo.com/video/${id}`);
      if (hash) embed.searchParams.set("h", hash);
      return { type: "vimeo", src: embed.href };
    }
  }

  if (DRIVE_HOSTS.has(host)) {
    const parts = u.pathname.split("/").filter(Boolean);
    const dIdx = parts.indexOf("d");
    const id = dIdx >= 0 ? parts[dIdx + 1] : u.searchParams.get("id");
    if (id) return { type: "drive", src: `https://drive.google.com/file/d/${id}/preview` };
  }

  return { type: "direct", src: u.href };
}
